module.exports = __webpack_public_path__ + "static/media/icon-xmc-tooltip.44f250a3.svg";